import { render, staticRenderFns } from "./SubaccountsTable.vue?vue&type=template&id=d99afa34&scoped=true"
import script from "./SubaccountsTable.vue?vue&type=script&lang=js"
export * from "./SubaccountsTable.vue?vue&type=script&lang=js"
import style0 from "./SubaccountsTable.vue?vue&type=style&index=0&id=d99afa34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99afa34",
  null
  
)

export default component.exports